export default __webpack_public_path__ + "static/media/icon_eye.43039890.svg";